// @flow
import { IncidenciasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    incidencia: {},
    listaIncidencias: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type IncidenciasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { incidencia?: {} | null, listaIncidencias?: [] | null, loading?: boolean, +value ?: boolean };

const Incidencias = (state: State = INIT_STATE, action: IncidenciasAction): any => {
    // console.log(action);
    switch (action.type) {
        case IncidenciasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case IncidenciasActionTypes.GET_INCIDENCIA: {
                    return {
                        ...state,
                        incidencia: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case IncidenciasActionTypes.LIST_INCIDENCIAS: {
                    return {
                        ...state,
                        listaIncidencias: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case IncidenciasActionTypes.ADD_INCIDENCIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case IncidenciasActionTypes.UPDATE_INCIDENCIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case IncidenciasActionTypes.DELETE_INCIDENCIA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case IncidenciasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case IncidenciasActionTypes.GET_INCIDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        incidencia: {},
                        loading: false,
                    };
                }
                case IncidenciasActionTypes.LIST_INCIDENCIAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaIncidencias: [],
                        loading: false,
                    };
                }
                case IncidenciasActionTypes.ADD_INCIDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case IncidenciasActionTypes.UPDATE_INCIDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case IncidenciasActionTypes.DELETE_INCIDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case IncidenciasActionTypes.GET_INCIDENCIA:
            return { ...state, error: false, loading: true };
        case IncidenciasActionTypes.LIST_INCIDENCIAS:
            return { ...state, error: false, loading: true };
        case IncidenciasActionTypes.ADD_INCIDENCIA:
            return { ...state, error: false, loadingForm: true };
        case IncidenciasActionTypes.UPDATE_INCIDENCIA:
            return { ...state, error: false, loadingForm: true };
        case IncidenciasActionTypes.DELETE_INCIDENCIA:
            return { ...state, error: false, loading: true };
        case IncidenciasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                incidencia: {},
                listaIncidencias: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Incidencias;
